import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClockCircleFillMini = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.0001 14.4001C9.69748 14.4001 11.3253 13.7258 12.5256 12.5256C13.7258 11.3253 14.4001 9.69748 14.4001 8.0001C14.4001 6.30271 13.7258 4.67485 12.5256 3.47461C11.3253 2.27438 9.69748 1.6001 8.0001 1.6001C6.30271 1.6001 4.67485 2.27438 3.47461 3.47461C2.27438 4.67485 1.6001 6.30271 1.6001 8.0001C1.6001 9.69748 2.27438 11.3253 3.47461 12.5256C4.67485 13.7258 6.30271 14.4001 8.0001 14.4001ZM8.6001 4.0001C8.6001 3.84097 8.53688 3.68836 8.42436 3.57583C8.31184 3.46331 8.15923 3.4001 8.0001 3.4001C7.84097 3.4001 7.68836 3.46331 7.57583 3.57583C7.46331 3.68836 7.4001 3.84097 7.4001 4.0001V8.0001C7.4001 8.3313 7.6689 8.6001 8.0001 8.6001H11.2001C11.3592 8.6001 11.5118 8.53688 11.6244 8.42436C11.7369 8.31184 11.8001 8.15923 11.8001 8.0001C11.8001 7.84097 11.7369 7.68836 11.6244 7.57583C11.5118 7.46331 11.3592 7.4001 11.2001 7.4001H8.6001V4.0001Z",
		fill: "currentcolor"
	})]
});
export default SvgClockCircleFillMini;
